import { render, staticRenderFns } from "./AcaoForm.vue?vue&type=template&id=4a93652d"
import script from "./AcaoForm.vue?vue&type=script&lang=js"
export * from "./AcaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports